import { api } from "#app/http/api";
import { CompanyDto } from "#modules/company/infra/Company.dto";
import { ApiError } from "#shared/infra/apiError";

export const fetchCompany = async (): Promise<CompanyDto | null> => {
  const response = await api.company.findMine.query();

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to fetch Company", response.status, response.body);
};
